import React from 'react';
import { Calendar, Clock } from 'lucide-react';

export const AppointmentCard = ({ appointment, onCancel, isCancelling }) => {
  return (
    <div
      dir="rtl"
      className="bg-white/70 backdrop-blur-sm border border-white/20 rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:bg-white/80"
    >
      {/* Top row: avatar, title, chips */}
      <div className="flex items-start gap-3">
        {/* Avatar */}
        <div className="w-12 h-12 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-rose-600 font-medium text-sm">
            {appointment.crew_member_name?.charAt(0) || 'T'}
          </span>
        </div>

        {/* Title + chips */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-semibold text-gray-900 text-sm leading-tight truncate">
              {appointment.service_name}
            </h3>

            {/* Chips */}
            <div className="flex items-center gap-2 flex-shrink-0">
              {/* Duration chip */}
              <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                {appointment.duration}דקות
              </span>

              {/* Status chip */}
              <span
                className={`px-2 py-1 rounded-full text-xs font-semibold whitespace-nowrap
                  ${appointment.status === 'pending_approval'
                    ? 'bg-amber-100 text-amber-800 border border-amber-200'
                    : appointment.status === 'scheduled'
                      ? 'bg-emerald-100 text-emerald-800'
                      : appointment.status === 'completed'
                        ? 'bg-green-100 text-green-800'
                        : appointment.status === 'cancelled'
                          ? 'bg-red-100 text-red-800'
                          : appointment.status === 'no_show'
                            ? 'bg-red-100 text-red-800'
                            : appointment.status === 'no_show_justified'
                              ? 'bg-orange-100 text-orange-800'
                              : 'bg-gray-100 text-gray-800'
                  }`}
              >
                {appointment.status === 'pending_approval' && 'ממתין לאישור'}
                {appointment.status === 'scheduled' && 'מאושר'}
                {appointment.status === 'completed' && 'הושלם'}
                {appointment.status === 'cancelled' && 'בוטל'}
                {appointment.status === 'no_show' && 'לא הגיע'}
                {appointment.status === 'no_show_justified' && 'לא הגיע - מוצדק'}
                {!['pending_approval', 'scheduled', 'completed', 'cancelled', 'no_show', 'no_show_justified'].includes(appointment.status) && appointment.status}
              </span>
            </div>
          </div>

          {/* Staff member */}
          <p className="text-gray-600 text-xs mt-1">{appointment.crew_member_name}</p>
        </div>
      </div>

      {/* Divider */}
      <div className="my-1 border-t border-white/20" />

      {/* Footer: date/time on right, cancel on left */}
      <div className="flex items-center justify-between">
        {/* Date & time */}
        <div className="flex items-center gap-4 text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            <span>{appointment.date}</span>
          </div>
          <div className="flex items-center gap-1">
            <Clock className="w-3 h-3" />
            <span>{appointment.time}</span>
          </div>
        </div>

        {/* Cancel button */}
        {(appointment.status !== 'cancelled' && appointment.status !== 'completed') && (
          <button
            onClick={() => onCancel(appointment.id)}
            disabled={isCancelling}
            className="bg-red-500/80 hover:bg-red-600/90 text-white px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
          >
            {isCancelling ? (
              <>
                <div className="w-3 h-3 border border-white/30 border-t-white rounded-full animate-spin"></div>
                מבטל...
              </>
            ) : (
              'ביטול תור'
            )}
          </button>
        )}
      </div>
    </div>
  );
};
